export default "__VITE_ASSET__CtA3umXt__"